const EVENTS = {

    APPLICATION_LOADED: 'application.loaded',
    APPLICATION_RELOAD: 'application.reload',

    OVERLAY_SHOWN: 'overlay.shown',
    OVERLAY_HIDDEN: 'overlay.hidden',

    NAVIGATION_TOGGLE: 'navigation.toggle',
    NAVIGATION_SHOW: 'navigation.show',
    NAVIGATION_HIDE: 'navigation.hide',

    LANGUAGE_SWITCHER_SHOW: 'language_switcher.show',
    LANGUAGE_SWITCHER_HIDE: 'language_switcher.hide',

    LOGIN_VALIDATE: 'login.validate',
    LOGIN_VALUES: 'login.values',
    LOGIN_ERROR: 'login.error',
    LOGIN_START: 'login.start',
    LOGIN_COMPLETE: 'login.complete',
    LOGIN_FAILED: 'login.failed',

    HISTORY_PUSH: 'window.history.push',
    HISTORY_POP: 'window.history.pop',
    HISTORY_POP_AND_PUSH: 'window.history.pop_and_push',
    STATE_CHANGE: 'state.change',

    VIEWPORT_CHANGE: 'viewport.change',
    VIEWPORT_RESIZE: 'viewport.resized',
    VIEWPORT_START: 'viewport.start',

    ARTICLES_FILTERS_SHOW: 'articles.filters.show',
    ARTICLES_FILTERS_HIDE: 'articles.filters.hide',

    ARTICLES_LOAD_MORE: 'articles.load_more',
    ARTICLES_LOADING_BEFORE: 'articles.loading.before',
    ARTICLES_LOADING: 'articles.loading',
    ARTICLES_LOADING_AFTER: 'articles.loading.after',
    ARTICLES_LOADED_BEFORE: 'articles.loaded.before',
    ARTICLES_LOADED: 'articles.loaded',
    ARTICLES_LOADED_AFTER: 'articles.loaded.after',

    SCREENER_RESULTS_SHOW_MESSAGE: 'screening.results.message.show',
    SCREENER_RESULTS_HIDE_MESSAGE: 'screening.results.message.hide',

};

export default EVENTS;